import React, { useEffect, useState } from 'react';
import { actualizarCliente } from '../../servicios/api';

const ModalEditarDatosCliente = ({ isOpen, cliente, onClose, onSaved }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    direccion: '',
    email: '',
    nif: '',
  });
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (!isOpen || !cliente) return;
    setFormData({
      nombre: cliente.nombre || cliente.nombre_cliente || '',
      telefono: cliente.telefono || '',
      direccion: cliente.direccion || '',
      email: cliente.email || cliente.correo_electronico || '',
      nif: cliente.nif || cliente.nie || cliente.dni || '',
    });
    setError('');
  }, [cliente, isOpen]);

  if (!isOpen || !cliente) return null;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.nombre.trim() || (!formData.telefono.trim() && !formData.email.trim())) {
      setError('Indica el nombre y al menos un teléfono o email.');
      return;
    }

    setGuardando(true);
    setError('');
    try {
      const respuesta = await actualizarCliente(cliente.id_cliente, formData);
      if (!respuesta.exito) {
        throw new Error(respuesta.mensaje || 'No se pudieron guardar los cambios.');
      }

      onSaved({
        ...cliente,
        ...formData,
        nombre_cliente: formData.nombre,
        correo_electronico: formData.email,
        nie: formData.nif,
      });
      onClose();
    } catch (saveError) {
      setError(saveError.response?.data?.mensaje || saveError.message || 'Error al guardar los datos.');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section role="dialog" aria-modal="true" aria-labelledby="editar-cliente-titulo" className="max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-lg border border-slate-700 bg-slate-900 p-6 text-slate-100 shadow-xl">
        <div className="mb-5 flex items-center justify-between border-b border-slate-700 pb-4">
          <h2 id="editar-cliente-titulo" className="text-xl font-semibold">Editar datos del cliente</h2>
          <button type="button" onClick={onClose} className="rounded px-3 py-1 text-slate-300 hover:bg-slate-800" aria-label="Cerrar">×</button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <p role="alert" className="mb-4 rounded border border-red-700 bg-red-950/50 px-3 py-2 text-sm text-red-200">{error}</p>}
          <div className="grid gap-4 sm:grid-cols-2">
            <label className="text-sm font-medium sm:col-span-2">
              Nombre
              <input name="nombre" value={formData.nombre} onChange={handleChange} required className="mt-1 w-full rounded border border-slate-600 bg-slate-800 px-3 py-2 text-white" />
            </label>
            <label className="text-sm font-medium">
              Teléfono
              <input name="telefono" type="tel" value={formData.telefono} onChange={handleChange} className="mt-1 w-full rounded border border-slate-600 bg-slate-800 px-3 py-2 text-white" />
            </label>
            <label className="text-sm font-medium">
              Email
              <input name="email" type="email" value={formData.email} onChange={handleChange} className="mt-1 w-full rounded border border-slate-600 bg-slate-800 px-3 py-2 text-white" />
            </label>
            <label className="text-sm font-medium sm:col-span-2">
              Dirección
              <input name="direccion" value={formData.direccion} onChange={handleChange} className="mt-1 w-full rounded border border-slate-600 bg-slate-800 px-3 py-2 text-white" />
            </label>
            <label className="text-sm font-medium sm:col-span-2">
              NIF / NIE
              <input name="nif" value={formData.nif} onChange={handleChange} className="mt-1 w-full rounded border border-slate-600 bg-slate-800 px-3 py-2 text-white" />
            </label>
          </div>
          <div className="mt-6 flex justify-end gap-3 border-t border-slate-700 pt-4">
            <button type="button" onClick={onClose} className="rounded border border-slate-600 px-4 py-2 text-sm hover:bg-slate-800">Cancelar</button>
            <button type="submit" disabled={guardando} className="rounded bg-orange-600 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-700 disabled:opacity-60">
              {guardando ? 'Guardando...' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ModalEditarDatosCliente;